<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="currentPassword" class="label">Aktualne hasło</label>
    <div class="passwordField">
      <input [type]="!show['currentPassword'] ? 'password' : 'text'" class="field" formControlName="currentPassword" id="currentPassword" autocomplete="newPassword">
      <button type="button" (click)="show['currentPassword'] = !show['currentPassword']">
        <svg *ngIf="!show['currentPassword']" style="height: 20px; width: 20px; " class="icon" viewBox="0 0 512 512" ><use xlink:href="#fa-eye" x="0" y="0" /></svg>
        <svg *ngIf="show['currentPassword']" style="height: 20px; width: 20px; " class="icon" viewBox="0 0 512 512" ><use xlink:href="#eye-slash" x="0" y="0" /></svg>
      </button>
    </div>

    <div class="errors" *ngIf="form.get('currentPassword').touched">
      <small *ngIf="form.get('currentPassword').hasError('required')">Pole jest wymagane</small>
      <small *ngIf="form.get('currentPassword').hasError('email')">Podaj adres e-mail</small>
      <div *ngIf="form.get('currentPassword').hasError('backend')">
        <small *ngFor="let error of form.get('currentPassword').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="newPassword" class="label">Nowe hasło</label>
    <div class="passwordField">
      <input [type]="!show['newPassword'] ? 'password' : 'text'" class="field" formControlName="newPassword" id="newPassword" autocomplete="newPassword">
      <button type="button" (click)="show['newPassword'] = !show['newPassword']">

        <svg *ngIf="!show['newPassword']" style="height: 20px; width: 20px; " class="icon" viewBox="0 0 512 512" ><use xlink:href="#fa-eye" x="0" y="0" /></svg>
        <svg *ngIf="show['newPassword']" style="height: 20px; width: 20px; " class="icon" viewBox="0 0 512 512" ><use xlink:href="#eye-slash" x="0" y="0" /></svg>

      </button>
    </div>

    <div class="errors" *ngIf="form.get('newPassword').touched">
      <small *ngIf="form.get('newPassword').hasError('required')">Pole jest wymagane</small>
      <small
        *ngIf="form.get('newPassword').hasError('hasLower') && !form.get('newPassword').hasError('required')">
        Wprowadź minimum 1 małą literę
      </small>
      <small
        *ngIf="form.get('newPassword').hasError('hasUpper') && !form.get('newPassword').hasError('required')">
        Wprowadź minimum 1 wielką literę
      </small>
      <small
        *ngIf="form.get('newPassword').hasError('hasNumber') && !form.get('newPassword').hasError('required')">
        Wprowadź minimum 1 cyfrę
      </small>
      <small
        *ngIf="form.get('newPassword').hasError('hasSpecial') && !form.get('newPassword').hasError('required')">
        Wprowadź minimum 1 znak specjlany
      </small>
      <small
        *ngIf="form.get('newPassword').hasError('minlength') && !form.get('newPassword').hasError('required')">
        Minimalna długoć hasła to 8 znaków
      </small>
      <div *ngIf="form.get('newPassword').hasError('backend')">
        <small *ngFor="let error of form.get('newPassword').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>


  </div>

  <div class="form-group">
    <label for="repeatPassword" class="label">Powtórz nowe hasło</label>
    <input type="password" class="field" formControlName="repeatPassword" id="repeatPassword" autocomplete="repeatPassword">
    <div class="errors" *ngIf="form.get('repeatPassword').touched">
      <small *ngIf="form.get('repeatPassword').hasError('required')">Pole jest wymagane</small>
      <small
      *ngIf="form.get('repeatPassword').hasError('matchOther') && !form.get('repeatPassword').hasError('required')">
      Hasła muszą być identyczne
    </small>

      <div *ngIf="form.get('repeatPassword').hasError('backend')">
        <small *ngFor="let error of form.get('repeatPassword').errors['backend'] | keyvalue">
          {{ error.value }}
        </small>
      </div>
    </div>
  </div>

  <div class="form-group text-center">
    <button class="btn btn-dark mt-4" type="submit">Zmień hasło</button>
  </div>

</form>
